const MetaListStyles = {
  metaDatListaWrapper: {
    padding: "20px 20px",
  },
  checkbox:{
    "& .MuiSvgIcon-root":{
      fontSize:"24px"
    },
    "& .MuiTypography-root":{
      fontSize:"14px"
    }
  },
  radioGroup:{
    padding:"20px"
  },
  menuItem:{
    "& .MuiTypography-root":{
      fontSize:"14px"
    }
  },
  autocompleteStyle: {
    overflow: "hidden", // Prevent vertical overflow
    "& .MuiAutocomplete-tag": {
      height: "auto",
    },
    "& .MuiChip-root": {
      maxWidth: "none", // Allow chips to take their natural size
      overflow: "hidden", // Prevent text overflow
    },
    "& .MuiChip-label": {
      fontSize: "11px", // Adjust font size for better fit
      padding: "0 8px",
    },
    "& .MuiAutocomplete-popupIndicator": {
      marginLeft: "auto",
    },
    "& .MuiTextField-root": {
      minHeight: "38px",
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: "4px",
      display: "flex",
      flexWrap: "wrap", // Allow chips to wrap to new lines
      overflow: "hidden", // Hide overflowing chips
      minHeight: "38px", // Ensure a minimum height
      maxHeight: "none", // No maximum height restriction
      fontSize: "14px",
      alignItems: "center", // Align items vertically
      padding: "2px 10px", 
      "&.Mui-focused fieldset": {
        borderColor: "#E7E7EA",
      },
      "&:hover fieldset": {
        borderColor: "#E7E7EA",
      },
    },
    "& .MuiAutocomplete-input": {
      minWidth: "0px",
    },
    "& .MuiSvgIcon-root": {
      display: "none",
    },
    "& .MuiAutocomplete-inputRoot": {
      paddingRight: "0px",
      alignItems: "center", // Center align chips and input
    },
  },
  
};

export default MetaListStyles;
